import apiService from "./api";

const creditService = {
  /**
   * Get active credits for a company
   * @param {number|string} companyId - Company ID
   * @returns {Promise}
   */
  getActiveCredits(companyId) {
    return apiService.post("/companies/get-active-credit", {
      company_id: companyId,
    });
  },

  /**
   * Add user credit
   * @param {Object} payload - Credit data
   * @returns {Promise}
   */
  addUserCredit(payload) {
    return apiService.post("/user/add-user-credit", payload);
  },

  /**
   * Edit user credit
   * @param {Object} creditData - Credit data to edit
   * @returns {Promise}
   */
  editUserCredit(creditData) {
    return apiService.post("/user/edit-user-credit", creditData);
  },

  /**
   * Delete user credit
   * @param {number|string} creditId - Credit ID
   * @returns {Promise}
   */
  deleteUserCredit(creditId) {
    return apiService.delete(`/user/credit/${creditId}`);
  },
};

export default creditService;
